import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id AAADBDE7-CC0D-4F69-A795-B38C0B00DC62
 * name menu-swap-outline
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/menu-swap-outline.svg
 * tags
 * - Arrow 
 */
export const MenuSwapOutlineIcon = createSvgIcon(<><path d="M12,3.5L6,9.5V11H18V9.5L12,3.5M12,6.33L14.67,9H9.33L12,6.33M6,13V14.5L12,20.5L18,14.5V13H6M9.33,15H14.67L12,17.67L9.33,15Z" /></>, 'MenuSwapOutlineIcon');
export default MenuSwapOutlineIcon